import { createGlobalStyle } from "styled-components";

export const GlobalStyles = createGlobalStyle`
  ::selection {
    background: ${({ theme }) => theme.colors.opacity_yellow};
  }
  button {
    transition: all 0.3s ease;
  }
  .hover-scale {
      transition: scale 0.3s ease;
      &:hover {
        cursor: pointer;
        scale: 1.1;
      }
    }
  /* Scrollbar style 1 */
  ::-webkit-scrollbar {
    width: 9px;
    height: 9px;
  }

  ::-webkit-scrollbar-track {
    background-color: #505050;
    border-radius: 0px;
  }

  ::-webkit-scrollbar-thumb {
    background-color: #2D2D2D;
    border-radius: 0px;
  }

  ::-webkit-scrollbar-thumb:hover {
    background-color: #3C3C3C;
  }

  /* Scrollbar style 2 */
  .scrollbar-style-2::-webkit-scrollbar {
    width: 9px;
    height: 9px;
  }

  .scrollbar-style-2::-webkit-scrollbar-track {
    background-color: #3C3C3C;
    border-radius: 0px;
  }

  .scrollbar-style-2::-webkit-scrollbar-thumb {
    background-color: #FFEF57;
    border-radius: 0px;
  }

  .scrollbar-style-2::-webkit-scrollbar-thumb:hover {
    background-color: #F7D700;
  }

  /* Define the custom font */
  @font-face {
    font-family: 'Kern Standard';
    src: url('${require("./assets/fonts/Kern-Standard-Regular.woff2")}') format('woff2');
    font-weight: normal;
    font-style: normal;
  }

  @font-face {
    font-family: 'Kern Standard';
    src: url('${require("./assets/fonts/Kern-Standard-Bold.woff2")}') format('woff2');
    font-weight: bold;
    font-style: normal;
  }
    
  html, body {
    font-size: 16px;
    height: 100%;
    overflow: hidden;
  }
  
  body {
    margin: 0;
    color: ${(props): string => props.theme.colors.white};
    font-family: ${(props): string => props.theme.fonts.body};
    background-color: ${(props): string => props.theme.colors.darkBg};
  }

  .top-bar-dashboard {
    width: 100%;
    background-color: ${(props): string => props.theme.colors.yellow};
    height: 65px;
  }

  .footer-dashboard {
    width: 100%;
    height: 65px;
    background-color: ${(props): string => props.theme.colors.darkBg};
    position: fixed;
    bottom: 0;
    left: 0;
    display: flex;
    justify-content: center;
    align-items: center;
  }
  .fade-enter {
    opacity: 0;
  }

  .fade-enter-active {
    opacity: 1;
    transition: opacity 300ms ease-in-out;
  }

  .fade-exit {
    opacity: 1;
  }

  .fade-exit-active {
    opacity: 0;
    transition: opacity 300ms ease-in-out;
  }
  progress {
    -webkit-appearance: none; /* For webkit browsers */
    appearance: none;
    width: 100%;
    height: 16px;
    border-radius: 5px;
    background-color: ${(props): string => props.theme.colors.darkBg}; /* Background color */
  }

  progress::-webkit-progress-bar {
      background-color: ${(props): string => props.theme.colors.darkBg}; /* Background color for webkit */
      border-radius: 5px;
  }

  progress::-webkit-progress-value {
      background-color: ${(props): string => props.theme.colors.yellow}; /* Progress color for webkit */
      border-radius: 5px;
      .progress-completed {
        background-color: ${(props): string => props.theme.colors.green}; /* Progress color */
      }
  }

  progress::-moz-progress-bar {
      background-color: ${(props): string => props.theme.colors.yellow}; /* Progress color for Firefox */
      border-radius: 5px;
      .progress-completed {
        background-color: ${(props): string => props.theme.colors.green}; /* Progress color */
      }
  }

.track-info-container {
    color: ${(props): string => props.theme.colors.yellow};
    width: 400px;
    overflow: hidden;
    white-space: nowrap;
    position: relative;
}

.track-info-wrapper {
    display: flex;
    width: max-content;
    animation: marquee 10s linear infinite;
}

.track-info-content {
    display: inline-block;
    flex-shrink: 0;
    min-width: max-content;
    padding-right: 20px;
}

@keyframes marquee {
    from {
        transform: translateX(0);
    }
    to {
        transform: translateX(-50%);
    }
}
`;
